import { getPagePath, trans } from '@spotahome/soyuz/client';

import LandingSection from '@spotahome/landings-common/src/components/LandingSection';

import TextBlock from './TextBlock';
import ImageBlock from './ImageBlock';

import HeadphonesIcon from './Icons/HeadphonesIcon';
import CompassIcon from './Icons/CompassIcon';

import './Help.scss';

const Help = () => {
  return (
    <LandingSection className="tenant-guarantees-help">
      <h2 className="tenant-guarantees-help__title">
        {trans('tenant_guarantees.help.title')}
      </h2>
      <div className="tenant-guarantees-help__content">
        <TextBlock
          className="tenant-guarantees-help__block-1"
          title={trans('tenant_guarantees.help.block1.title')}
          description={trans('tenant_guarantees.help.block1.description')}
          cta={{
            text: trans('tenant_guarantees.help.read.article'),
            url: getPagePath('externals.blog.avoid-deposit-disputes-guide')
          }}
        />
        <ImageBlock
          className="tenant-guarantees-help__block-2"
          title={trans('tenant_guarantees.help.block2.title')}
          cta={{
            text: trans('tenant_guarantees.help.block2.cta'),
            url: getPagePath('support-contact-form')
          }}
          renderImage={() => (
            <CompassIcon className="tenant-guarantees-help-image-block__image" />
          )}
        />
        <ImageBlock
          className="tenant-guarantees-help__block-3"
          title={trans('tenant_guarantees.help.block3.title')}
          cta={{
            text: trans('tenant_guarantees.help.block3.cta'),
            url: getPagePath('externals.help-center')
          }}
          renderImage={() => (
            <HeadphonesIcon className="tenant-guarantees-help-image-block__image" />
          )}
        />
        <TextBlock
          className="tenant-guarantees-help__block-4"
          title={trans('tenant_guarantees.help.block4.title')}
          description={trans('tenant_guarantees.help.block4.description')}
          cta={{
            text: trans('tenant_guarantees.help.read.article'),
            url: getPagePath(
              'externals.blog.what-guarantees-does-spotahome-offer'
            )
          }}
        />
      </div>
    </LandingSection>
  );
};

export default Help;
